import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPalette } from '@fortawesome/free-solid-svg-icons';

interface ColorMenuSelectorProps {
  currentColor: string;
  onColorChange: (newColor: string) => void;
  menuIndex: number | null;
  thisIndex: number;
  setMenuIndex: (index: number | null) => void;
  menuRef: React.RefObject<HTMLDivElement>;
  presetColors: string[];
  size?: number;
}

export default function ColorSelectorMenu({
  currentColor,
  onColorChange,
  menuIndex,
  thisIndex,
  setMenuIndex,
  menuRef,
  presetColors,
  size = 24,
}: ColorMenuSelectorProps) {
  const toggleMenu = () => {
    setMenuIndex(menuIndex === thisIndex ? null : thisIndex);
  };

  const handleColorSelect = (color: string) => {
    onColorChange(color);
    setMenuIndex(null);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={toggleMenu}
        style={{
          width: size,
          height: size,
          backgroundColor: currentColor,
          borderRadius: 4,
          border: '1px solid #ccc',
          cursor: 'pointer',
        }}
        title="Click to change color"
      />

      {menuIndex === thisIndex && (
        <div
          ref={menuRef}
          style={{
            position: 'absolute',
            top: 30,
            left: -5,
            zIndex: 1000,
            border: '1px solid #ccc',
            backgroundColor: 'var(--bs-body-bg)',
            borderRadius: 6,
            padding: '2px 8px',
            display: 'flex',
            gap: 8,
            alignItems: 'center',
          }}
        >
          {presetColors.map(color => (
            <div
              key={color}
              onClick={() => handleColorSelect(color)}
              style={{
                width: 20,
                height: 20,
                backgroundColor: color,
                borderRadius: 4,
                border: '1px solid #999',
                cursor: 'pointer',
              }}
              title={color}
            />
          ))}

          <label
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 28,
              height: 28,
              borderRadius: 4,
              border: '1px solid #999',
              cursor: 'pointer',
              position: 'relative',
            }}
            title="Pick custom color"
          >
            <FontAwesomeIcon icon={faPalette} style={{ color: currentColor, fontSize: 18 }} />
            <input
              type="color"
              value={currentColor}
              onChange={e => handleColorSelect(e.target.value)}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                opacity: 0,
                cursor: 'pointer',
              }}
            />
          </label>
        </div>
      )}
    </div>
  );
}
